<template>
  <div class = "user-class-area">
    <div class = "join-classroom">
      <h2> ¿Quieres apuntarte a una clase?</h2>
      <p> Una clase es simplemente un grupo al que puedes añadir tus proyectos. Tu profesor o mentor podrá verlos</p>
      <join-classroom v-on:success="loadClassData"></join-classroom>
    </div>

    <div class="classrooms">
      <div class="classroom" v-for="classroom in myUserInfo.classroom_set" :key="classroom.id">
        <div class = "header">
          <div class = "info">
            <h2> {{classroom.name}} </h2>
            <p> {{classroom.description}} </p>
          </div>
        </div>
        <div class = "content">
          <p><strong> Profesor: </strong> {{classroom.customuser_set[0].name?classroom.customuser_set[0].name:"El profesor no ha publicado su nombre" }} </p>
          <h3 v-if="getProjectsInClassroom(classroom.id).length>0"> Proyectos compartidos del profesor</h3>

          <div class="list project-list">
            <div  v-for="project in getProjectsInClassroom(classroom.id)" :key="project.id" class="project">
              <router-link :to="'/editor/'+project.id">
                <img :src="project.cover" v-if="project.cover" />
                <img src="/static/img/nocover.png" v-else />
                <div> {{ project.name }} </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import JoinClassroom from './JoinClassroom'

export default {
  name: 'UserClassArea',
  components: {
    JoinClassroom
  },
  props: {},
  computed: {
    myUserInfo () {
      return this.$store.state.user.userInfo
    }
  },
  methods: {
    loadClassData: function () {
      this.$store.dispatch('user/fetchUserInfo')
        .then(() => {
          // if I am student get all projects shared in the classes I belong
          this.$store.state.user.userInfo.classroom_set.forEach((classroom) => {
            let classroomOwner = classroom.customuser_set[0]
            this.$store.dispatch('user/student_fetchProjectsSharedInMyClassroom', {'classid': classroom.id, 'teacherid': classroomOwner.id})
          })
        })
    },
    getProjectsInClassroom: function (classid) {
      if (this._.has(this.$store.state.user.student_projectsInMyClassrooms, classid)) {
        return this.$store.state.user.student_projectsInMyClassrooms[classid]
      } else return []
    }
  },
  created () {
    this.loadClassData()
  }
}

</script>

<style lang="less">
@import (reference) "../../assets/styles/main.less";

.user-class-area {
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;

  & > div {
    padding: 20px;
  }
}

.join-classroom {
  flex: 2;

  p {
    margin-bottom: 15px;
  }
}

.classrooms {
  flex: 3;
}

.classroom {
  overflow: hidden;
  position: relative;
  margin-bottom: 35px;
  box-shadow: 0px 0px 1px 1px #0002;
  background: @lightGray;

  & > div {
    padding: 12px;
  }

  .header {
    display: flex;
    justify-content: space-between;

    .institution {
      color: #8c8c8c;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/UserClassArea.vue